{
  "conversations": {
    "conversationsApp": "Konversations-App",
    "locationId": "Standort-ID",
    "idToken": "ID-Token",
    "conversationRoutes": "Konversationsrouten",
    "conversationProviders": "Konversationsanbieter",
    "viewTheListOfConversation": "Ansicht der Liste von Konversationen Benutzerdefiniert-Anbieter hinzugefügt zum Konto hier.",
    "logo": "Logo",
    "name": "Name",
    "alias": "Alias",
    "type": "eintippen"
  }
}
